import { useEffect } from "react";
import { IStaffTrainingMatrics } from "../../../../models/staff/employeeTraining";
import { setTrainingMatrics } from "../../../../store/slices/staff/trainingCompletionDetailsSlice";
import { connect, useDispatch } from "react-redux";
import { getTrainingCompletionDetails } from "../../../../action/staff/trainingCompletionDetailsActionCreator";

const TrainingMatrics = (props: IStaffTrainingMatrics) => {
  const { getTrainingMatrics, trainingMatrics } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    getTrainingMatrics();
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setTrainingMatrics([]));
    };
  }, []);
  return (
    <>
      <div className="col-lg-12 mb-3">
        <div className="card-wrap">
          <div className="title mb-28">
            <h2 className="mb-28">Training Metrics</h2>
          </div>
          <div className="snapshot-wrap d-flex flex-column p-0">
            <div className="snapshot-card">
              <div className="icon">
                <img src="/assets/images/icon/certificates.svg" alt="" />
              </div>
              <div className="desc">
                <h5>{trainingMatrics?.certificates}</h5>
                <p>Certificates Issued</p>
              </div>
            </div>
            <div className="snapshot-card">
              <div className="icon">
                <img src="/assets/images/icon/check.svg" alt="" />
              </div>
              <div className="desc">
                <h5>{trainingMatrics?.trainingCompleted}</h5>
                <p>Training Completed</p>
              </div>
            </div>
            <div className="snapshot-card">
              <div className="icon">
                <img src="/assets/images/icon/close.svg" alt="" />
              </div>
              <div className="desc">
                <h5>{trainingMatrics?.notTaked}</h5>
                <p>Training Not Taken</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getTrainingMatrics: () => getTrainingCompletionDetails(),
};

function mapStateToProps(state: any) {
  return {
    trainingMatrics: state.trainingMatrics.trainingMatrics
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainingMatrics);
